<template>
    <div>
        <ExtrasDialog
                :car="car"
                :show-extras-dialog="showExtrasDialog"
                @close-dialog="showExtrasDialog = false"
        />

        <v-layout
                 wrap justify-space-between :class="{ 'selected-row': isSelected }"
                class="car-list-item v-card elevation-2"
        >
            <v-flex
                    :md1="presentationOnly"
                    :md2="!presentationOnly"
                    class="centered-icon"
                    style="text-align: center"
            >
                <v-btn
                        @click="gepjarmuBetolt()"
                        color="primaryButtonColor"
                        style="color: var(--v-primaryButtonTextColor-base);"
                        v-if="!presentationOnly"
                        small
                        class="button"
                >
                    <span>{{ isSelected ? 'Kiválasztva' : 'Kiválaszt'}}</span>
                </v-btn>
            </v-flex>

            <v-flex :md10="presentationOnly" :md9="!presentationOnly" style="padding-top: 10px;">
                <v-layout  wrap justify-space-between>
                    <v-flex xs12 class="ma-1 bold">
                        {{ car.gyartmany }}
                        {{ car.modell_generacio === car.modell_rovidnev ? car.modell_generacio : car.modell_generacio +
                        ' ('
                        + car.modell_rovidnev + ')' }}
                        {{ car.tipusnev }}
                    </v-flex>
                    <v-flex xs12 class="ma-1">
                        <v-layout wrap>
                            <v-flex
                                    xs4
                                    class="car-data-item"
                            >
                                {{ +car.hengerurtartalom }} cm<sup>3</sup>
                            </v-flex>
                            <v-flex
                                    xs4
                                    class="car-data-item"
                            >
                                {{ +car.teljesitmeny_kw }} kW
                                <span v-if="+car.teljesitmeny_le">/ {{ +car.teljesitmeny_le }} LE</span>
                                <span v-if="+car.teljesitmeny_kw_2">({{ +car.teljesitmeny_kw_2 }} kW)</span>
                            </v-flex>
                            <v-flex
                                    xs4
                                    class="car-data-item"
                            >
                                {{ car.valto_tipusa }} váltó
                            </v-flex>
                            <v-flex
                                    v-if="+car.ajtok_szama > 0"
                                    xs4
                                    class="car-data-item"
                            >
                                {{ car.ajtok_szama }} ajtós
                            </v-flex>
                            <v-flex
                                    v-if="+car.ferohelyek_szama > 0"
                                    xs4
                                    class="car-data-item"
                            >
                                {{ car.ferohelyek_szama }} személyes
                            </v-flex>
                            <v-flex
                                    xs4
                                    class="car-data-item"
                            >
                                {{ car.kivitel }}
                            </v-flex>
                            <v-flex
                                    xs4
                                    class="car-data-item"
                            >
                                {{ car.sajat_tomeg }} kg
                            </v-flex>
                            <v-flex
                                    v-if="+car.ossztomeg > 0"
                                    xs4
                                    class="car-data-item"
                            >
                                {{ car.ossztomeg }} kg
                            </v-flex>
                            <v-flex
                                    xs4
                                    class="car-data-item"
                            >
                                <v-icon> {{ getTypeIcon(car.gepjarmu_tipus) }}</v-icon>
                                {{ getType(car.gepjarmu_tipus) }}
                            </v-flex>
                            <v-flex
                                    xs4
                                    class="car-data-item"
                            >
                                {{ car.gyartasi_ev_tol }} - {{ car.gyartasi_ev_ig ? car.gyartasi_ev_ig : 'Még gyártják'
                                }}
                            </v-flex>
                            <v-flex
                                    xs4
                                    class="car-data-item"
                            >
                                {{ numberWithCurrency(car.ar) }} Ft
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex
                    md1
                    class="centered-icon"
            >
                <v-tooltip top>
                    <template v-slot:activator="{on}">
                        <v-icon v-on="on" @click="showExtrasDialog = true"> info
                        </v-icon>
                    </template>
                    <span> Felszereltség megjelenítése </span>
                </v-tooltip>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import EventBus from '../../modules/EventBus';
import ExtrasDialog from './ExtrasDialog.vue';

export default {
    name: 'EtaxCarRow',
    components: { ExtrasDialog },
    data() {
        return {
            extrakVisible: false,
            extrak: '',
            hasExtras: false,
            selected: false,
            showAllExtras: false,
            showExtrasDialog: false,
        };
    },

    computed: {
        isSelected() {
            return this.car.eurotax === this.eurotaxcode;
        },
    },

    props: {
        car: {
            required: true,
        },
        presentationOnly: {
            default: false,
        },
        eurotaxcode: {
            default: null,
            required: false,
        },
    },
    methods: {

        numberWithCurrency(number) {
            return new Intl.NumberFormat(
                'hu-HU',
                {
                    style: 'decimal',
                },
            ).format(
                number,
            );
        },
        chShowAllExtras() {
            this.showAllExtras = !this.showAllExtras;
        },
        getType(typeCode) {
            switch (typeCode) {
            case 10:
                return 'Személyautó';
            case 20:
                return 'Kishaszon gépjármű';
            case 30:
                return 'Motorkerékpár';
            case 40:
                return 'Terepjáró';
            default:
                return '';
            }
        },
        getTypeIcon(typecode) {
            const map = {
                10: 'time_to_leave',
                20: 'local_shipping',
                30: 'two_wheeler',
                40: '',
            };
            return map[typecode];
        },
        gepjarmuBetolt() {
            EventBus.$emit('selected-car', this.car.eurotax);
        },

        clearEtax() {
            EventBus.$emit('selected-car', null);
        },
    },
};
</script>

<style scoped>
    .centered-icon {
        width: 100%;
        height: 100%;
        margin: auto;
    }

    .selected-row {
        background-color: #e0e0e0;
    }

    .low-opacity {
        opacity: 0.5;
    }

    .car-data-item {
        padding-right: 10px;
        padding-bottom: 10px;
    }

    .bold {
        font-weight: bold;
    }

    .car-list-item {
        margin: 5px;
        border: 1px solid #cbcbcb;
    }

</style>
